import React, { useState } from 'react';

import {
    Menu,
    Stack,
    Button,
    MenuItem,
    ButtonGroup,
    Paper,
    Chip,
    Typography,
    Divider,
    styled,
    Card,
    Grid,
    Box,
    ListItemText,
} from '@mui/material';

import { useAppContextFeatures } from '../../context/AppContext';
import { useAuthAccess } from '../../hooks/useAuthAccess'
import { CommonIcons, icons } from '../common/CommonIcons';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useTranslations } from "../../hooks/useTranslations";

import CommonSectionHeader from '../common/CommonSectionHeader';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function LocationSelector(
    {
        authTargetType,
        config,
        maxSelect = 999,
        handleOnNext
    }
) {

    const { t, getTranslations } = useTranslations({ ns: ["_prompt", "prompt", "common"] })

    // console.log('aa', getTranslations())

    const { title, description } = config

    const { getAvailableLocations } = useAuthAccess(authTargetType);
    const { setLocationIds } = useAppContextFeatures();
    const { promptMessage } = useSystemPrompt();

    const availableLocations = getAvailableLocations();

    const [selected, setSelected] = useState([])
    // const [ selectedItem, setSelectedItem ] = useState([])

    const handleSelect = ({ id, item }) => {

        // console.log('id, i', id, item)

        // check the id selected in the array
        const check = selected.filter(item => item.id === id)

        let newSelected;
        let newSelectedItem;

        if (check.length) { // found
            newSelected = selected.filter(item => item.id !== id)
        } else {// not found

            // check the max is required to check
            if ((selected.length + 1) > maxSelect) {
                promptMessage(false, `${t('maxOnlyAllowed', { no: maxSelect })}`)
                return false;
            }

            newSelected = [...selected, item]

        }

        setSelected(newSelected)
        // setSelectedItem(newSelectedItem);

        return true;

    }

    const checkIsSelected = ({ id }) => {
        return selected.find(i => i.id === id)
    }

    const RenderSelection = () => {
        return (
            <StyledCard
                sx={{
                    p: 4
                }}
            >
                <Grid container spacing={3}>
                    <Grid item md={12} xs={12} sm={12}>
                        <CommonSectionHeader
                            title={title}
                            subTitle={description}
                        />
                    </Grid>
                    <Grid item md={12} xs={12} sm={12}>
                        <Grid container spacing={1}>
                            {
                                availableLocations && availableLocations.map((item, index) => {

                                    return (
                                        <Grid item md={3} xs={6} sm={4} key={index}>
                                            <Button
                                                fullWidth
                                                color={"primary"}
                                                variant={checkIsSelected({ id: item?.id }) ? 'contained' : 'outlined'}
                                                sx={{
                                                    // display: "block",
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    px: 2,
                                                    py: 1,
                                                    minHeight: 80,
                                                }}
                                                onClick={() => {
                                                    handleSelect({ id: item?.id, item })
                                                }}
                                            >
                                                {/* <StyledIcon
                                                    textAlign={"center"}
                                                    alignSelf={"center"}
                                                    sx={{
                                                        // width: '100%',
                                                        height: 40,
                                                        // mb: 1,
                                                        // backgroundColor: 'red',
                                                        // textAlign: 'center',
                                                        // justifyContent: 'center',
                                                        // alignItems: 'center'
                                                    }}
                                                >
                                                    <CommonIcons name={icons.warehouse} sx={{ width: 40, height: 40 }} />
                                                </StyledIcon> */}
                                                <CommonIcons name={icons.warehouse} sx={{ width: 40, height: 40 }} />
                                                <Box sx={{ ml: 1, textAlign: 'left' }}>
                                                    {/* <ListItemText
                                                        primary={item?.location_name}
                                                        secondary={item?.state_name}
                                                        sx={{
                                                            textAlign: 'left',
                                                        }}
                                                    /> */}
                                                    <Typography
                                                        // variant="h8"
                                                        sx={{
                                                            fontSize: '1.0rem',
                                                            fontWeight: 800
                                                        }}
                                                    >
                                                        {item?.location_name}
                                                    </Typography>
                                                    <Typography
                                                        // variant="body1"
                                                        sx={{
                                                            fontSize: '0.8rem'
                                                        }}
                                                    >
                                                        {item?.area_name} {item?.state_name}, {item?.country_name}
                                                    </Typography>
                                                </Box>
                                            </Button>
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    return (
        <>

            {/* <RenderSelection /> */}

            {
                RenderSelection()
            }

            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        // fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                        onClick={() => {

                            if (selected && selected.length < 1) {
                                promptMessage(false, t('selectionRequired'))
                                return false;
                            }

                            handleOnNext({ selected })

                            return true;
                        }}
                    >
                        {t('next')}
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}